<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable min-width="90%" min-height="90%">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title style="padding: 10px 0 0 10px; height: 20px;">
            <v-col cols="12">
                          <span style="font-size: 20px;">
                              {{ !data.id ? 'Nuevo diálogo' : 'Editar diálogo' }}
                          </span>
            </v-col>
          </v-card-title>
          <v-card-text style="padding-bottom: 0;"  @wheel="onWheel">
            <v-container style='max-width:100%'>
                          <v-form ref="form">
  
                              <v-tabs v-model="tab" v-if="!loading" style="margin-top: 20px;">
                                  <v-tab href="#dg">Datos generales</v-tab>
                                  <v-tab href="#formio">Formulario</v-tab>
                                    </v-tabs>

                                    <v-tabs-items  v-if="!loading" v-model="tab">
                                          <v-tab-item eager value="dg">
                                             
                                                <v-row style="margin-top: 20px;">

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.title"
                                                               :label="'Título'"
                                                               autocomplete="none"
                                                               :rules="[validationRules.required]"
                                                               :hint="$t(data.title)" persistent-hint
                                                               max="200"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.description"
                                                               :label="'Descripción'"
                                                               autocomplete="none"
                                                               :rules="[validationRules.required]"
                                                               :hint="$t(data.description)" persistent-hint
                                                               max="300"
                                                         />
                                                      </v-col>
                     
                                                      <v-col cols="12">
                                                         <v-select
                                                               chips
                                                               multiple
                                                               v-model="readRolesAllowed"
                                                               :items="roles"
                                                               menu-props="bottom, offsetY"
                                                               label="Roles lectura"
                                                         />
                                                      </v-col>

                                                      <v-col cols="12">
                                                         <v-select
                                                               chips
                                                               multiple
                                                               v-model="writeRolesAllowed"
                                                               :items="roles"
                                                               menu-props="bottom, offsetY"
                                                               label="Roles escritura"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.getEndpoint"
                                                               :label="'GET Endpoint - leer)'"
                                                               autocomplete="none"
                                                               max="200"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.putEndpoint"
                                                               :label="'PUT Endpoint - crear'"
                                                               autocomplete="none"
                                                               max="300"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.postEndpoint"
                                                               :label="'POST Endpoint - actualizar y crear (si PUT endpoint es nulo)'"
                                                               autocomplete="none"
                                                               max="200"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.deleteEndpoint"
                                                               :label="'DELETE Endpoint - eliminar'"
                                                               autocomplete="none"
                                                               max="300"
                                                         />
                                                      </v-col>
                                                </v-row>
                                          </v-tab-item>
                                          <v-tab-item eager value="formio">
                                             <iframe ref='builder'  frameBorder="0" width='100%' height='650' style='padding-top:20px' :src="'form-builder.html?callbackId='+callbackId"/>
                                          </v-tab-item>
                                    </v-tabs-items>

                           
                          </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
          <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import ConfirmDialog from '../../common/ConfirmDialog'
import { Formio } from 'formiojs';
import {
   Constants
} from '../../common/Constants'
import api from '../../../api/worktime'

export default {
   name: 'EditDialog',
   mixins: [BaseModule],
   components: {
      ConfirmDialog
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         readRolesAllowed: [],
         writeRolesAllowed: [],
         tab: "#dg",
         formBuilder: null,
         data: {},
         callbackId: 'form-builder-'+(new Date().getTime()),
      }
   },
   methods: {
      validateJSON: function (item) {
         if (!item) {
            return true;
         }

         try {
            JSON.parse(item);
         } catch (e) {
            return e.message;
         }

         return true;
      },
      // eslint-disable-next-line no-unused-vars
      open: function (action, payload) {

         this.showDialog = true;
         this.tab= "#dg";
         this.roles = Constants.roles;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

         if (!payload) {
            this.data = {
               enabled: 1,
            };
            this.readRolesAllowed = [];
            this.writeRolesAllowed = [];
            setTimeout (this.createBuilder ,1000);
            this.loading = false; 
            return;
         }

         this.loading = true;
         api.getDialog(payload, res => {
            this.data = res;
            this.rolesAllowed = [];
            if (this.data.readRolesAllowed) { // pasamos de lista separado por comas a array
               this.readRolesAllowed = this.data.readRolesAllowed.split(",").map(function (item) {
                  return item.trim();
               });
            }
            if (this.data.writeRolesAllowed) { // pasamos de lista separado por comas a array
               this.writeRolesAllowed = this.data.writeRolesAllowed.split(",").map(function (item) {
                  return item.trim();
               });
            }

            //En caso de estar duplicando, eliminamos el id para forzar un nuevo registro
            if (action === 'DUPLICATE') {
               this.data.id = undefined;
            }

            setTimeout (() => this.createBuilder(this.data.formDefinition) ,1000);

            this.loading = false;
         }, error => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })


      },
      onSave: function () {
         if (!this.$refs.form.validate()) {
            return;
         }

         if (this.readRolesAllowed.length > 0) {
            this.data.readRolesAllowed = this.readRolesAllowed.join();
         } else {
            this.data.readRolesAllowed = null;
         }
 
         if (this.writeRolesAllowed.length > 0) {
            this.data.writeRolesAllowed = this.writeRolesAllowed.join();
         } else {
            this.data.writeRolesAllowed = null;
         }

         this.loading = true;
         // eslint-disable-next-line no-unused-vars
         api.storeDialog(this.data,res => {
               this.loading = false;
               this.showDialog = false;
               this.$emit('refresh');
            },
            error => {
               this.$log.error(error);
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      onWheel(event) {
            event.stopPropagation()
        },
      deleteItem() {
        this.loading = true;
        // eslint-disable-next-line no-unused-vars
         api.deleteDialog(this.data.id, res => {
               this.showDialog = false;
               this.loading = false;
               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            }
         );
      },
      createBuilder(definition) {
            let options = {};
            const vm = this;
            Formio.builder(vm.$refs['fb-formio-container'], {}, options).then(function(builder) {
                    vm.formBuilder = builder;
                    builder.setForm(definition?JSON.parse(definition):{});

                    //builder.on('saveComponent', this.onFormSchemaUpdated);
                    //builder.on('removeComponent', this.onFormSchemaUpdated);
                    //builder.on('addComponent', this.onFormSchemaUpdated);
                    //builder.on('updateComponent', this.onFormSchemaUpdated);
                });

      },
      onFormSchemaUpdated() {
      },
      processMessage(msg) {
          if (!msg.data) return;

          if (!msg.data.target || msg.data.target!=this.callbackId) return;

          if (msg.data.type==='ready') {
              this.$refs.builder.contentWindow.postMessage(this.data.formDefinition?this.data.formDefinition:'{}');
              return;
          }


          if (msg.data.type==='schemaUpdate') {
              this.data.formDefinition = JSON.stringify(msg.data.payload);
                return;
          }
          
        },
   },
   mounted: function ()  {
         if (window.addEventListener) {
                window.addEventListener("message", this.processMessage, false);
            }
            else {
                window.attachEvent("onmessage", this.processMessage);
            }
      
  },
}
</script>